/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

let Constants = {
    install(Vue){
        Vue.prototype.Constants = {
            SCROLL_TIME : '07:00:00',
            STATUS_PRE_BOOKED : 100,
            STATUS_BOOKED : 200,
            STATUS_CONFIRMED : 210,
            STATUS_ARRIVED : 220,
            STATUS_COMPLETED : 240,
            STATUS_RESCHEDULED : 500,
            STATUS_EARLY_CANCELLED : 800,
            STATUS_LATE_CANCELLED : 880,
            STATUS_NO_SHOW : 890,
            BOOKING_TYPE_ADD_STAFF_BREAK : 1,
            BOOKING_TYPE_EDIT_STAFF_BREAK : 4,
            BOOKING_TYPE_DELETE_STAFF_BREAK : 5,
            BOOKED_THROUGH_ADMIN : 1,
            BOOKED_THROUGH_CUSTOMER : 2,
            UPDATED_THROUGH_CUSTOMER : 2,
            WORKING_STATUS_INDICATOR_EDIT_STAFF_HOURS : 0,
            STATUS_BOOKED_EVENT_COLOUR : "#5BCDE9",
            STATUS_ARRIVED_EVENT_COLOUR : "#0084F4",
            STATUS_COMPLETED_EVENT_COLOUR : "#10A377",
            STATUS_NO_SHOW_EVENT_COLOUR : "#FFBB66",
            STATUS_EARLY_CANCELLED_EVENT_COLOUR : "#D00000",
            STATUS_LATE_CANCELLED_EVENT_COLOUR : "#D00000",
            BOOKING_TYPE_EDIT_BOOKING:7,
            BOOKING_TYPE_RESCHEDULE_BOOKING:6,
            CLIPBOARD_EVENT_FROM_CALENDAR:0,
            CLIPBOARD_EVENT_FROM_RESCHEDULE:1,
            CLIPBOARD_EVENT_FROM_REBOOK:2,
            EDIT_FLAG:1,
            UPLOAED_IMAGE_FLAG:0,
            CROP_IMAGE_FLAG:1,
            DELETE_IMAGE_FLAG:2,
            IMAGE_UPLOAD_STATUS_SUCCESS:200,
            TIME_FORMAT : "hh:mm A",
            HUMAN_DATE_FORMAT: "DD MMM YYYY, hh:mm A",
            DATE_FORMAT: "MMM DD,  YYYY",
            WEEK_DATE_FORMAT : "ddd, MMM DD,  YYYY",
            CRYPTO_KEY: "8DQ1DABA8A4EE292A832E4C5BB7WC",
            DEPOSIT_FLAG:1,
            FULL_AMOUNT_FLAG:2,
            DEFAULT_STORE_OPEN_TIME:'09:00:00',
            DEFAULT_STORE_CLOSE_TIME : '18:00:00',
            time_zones:[{country_code:"91",time_zone:'Asia/Kolkata,10'},{country_code:"61",time_zone:'Australia/Brisbane,9'},{country_code:"65",time_zone:'Asia/Singapore,8'},{country_code:"44",time_zone:'Europe/London,10'},{country_code:"1",time_zone:'America/New_York,10'},{country_code:"64",time_zone:'Pacific/Auckland,9'}] 


        }
    }
}

export default Constants;
